(function() {
    angular.module('emarket.commons').filter('translate', ['TRANSLATION', function(TRANSLATION) {
        return function(value) {
            return TRANSLATION[value] ? TRANSLATION[value] : value;
        };
    }]);
}());
